import React, { useState } from 'react';
import '../styles/LawRegister.css';

const LawRegister = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    dob: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('http://localhost:5000/api/email/send-law-registration', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      setLoading(false);

      if (response.ok) {
        alert('Registration successful! Email sent.');
        setFormData({ fullName: '', email: '', phone: '', dob: '' });
      } else {
        alert(data.error || 'Failed to send registration email.');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error sending registration:', error);
      alert('Failed to send registration email.');
    }
  };

  return (
    <div className="law-register-container">
      <div className="law-register-card">
        <h2>Law Service Registration</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="date"
            name="dob"
            placeholder="Date of Birth"
            value={formData.dob}
            onChange={handleChange}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Register'}
          </button>
        </form>

        {loading && <div className="spinner"></div>}
      </div>
    </div>
  );
};

export default LawRegister;
